import React from "react";
import { colors } from "../../../../../themes/Colors";
import { BaseButtons, TextInputFieldArea } from "../../../../common-components";

const KeyNoticeTransferNotePopUp = ({
  display,
  selectedNotice,
  onCancelClick,
  selectedAnswer,
  noteValue,
  onNoteChange,
  onSubmitClick,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        height: display ? "100%" : 0,
        overflow: "hidden",
        backgroundColor: colors.white,
      }}
    >
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          position: "absolute",
        }}
      >
        <BaseButtons
          label={"CANCEL"}
          width={"90%"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          onClick={onCancelClick}
        />
      </div>
      <div
        style={{
          marginTop: 80,
          width: "100%",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div style={{ width: "80%" }}>
          YOU HAVE {selectedAnswer} THE TRANSFER NOTICE, WOULD YOU LIKE TO LEAVE
          A NOTE ? IF NOT THE COMPLETE THE PROCESS BY CLICKING SUBMIT
        </div>
      </div>
      <TextInputFieldArea
        mini={true}
        labelTitle={"NOTE"}
        width={"100%"}
        size={"75%"}
        height={100}
        value={noteValue}
        onChange={onNoteChange}
      />

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <BaseButtons
          label={"SUBMIT RESPONSE"}
          width={"90%"}
          backgroundColor={colors.greenLight}
          borderRadius={8}
          onClick={onSubmitClick}
        />
      </div>
    </div>
  );
};

export default KeyNoticeTransferNotePopUp;
